import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

const STORE_PHONE_TEL = "+12518612320";        // for tel: link
const STORE_PHONE_DISPLAY = "(251) 861-2320";

// Routes where the floating button should be HIDDEN (staff / admin surfaces + login pages).
const HIDDEN_PREFIXES = [
  "/kitchen",
  "/admin",
  "/employee",
  "/instore",
  "/login",
];

/**
 * FloatingCallButton — round FAB pinned bottom-right that dials the store.
 * Rendered globally from App.js. Auto-hides on staff / admin / login routes.
 */
export default function FloatingCallButton() {
  const location = useLocation();
  const hidden = HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));
  if (hidden) return null;

  return (
    <a
      href={`tel:${STORE_PHONE_TEL}`}
      aria-label={`Call us at ${STORE_PHONE_DISPLAY}`}
      title={`Call us at ${STORE_PHONE_DISPLAY}`}
      data-testid="floating-call-btn"
      className="fixed z-50 flex items-center gap-2 rounded-full text-white font-semibold shadow-lg transition-transform active:scale-95"
      style={{
        // Sit just above iOS home indicator and above the ChevronToTop / any other FAB.
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 20px)",
        right: "16px",
        backgroundColor: "#16A34A",
        padding: "12px 16px",
        boxShadow: "0 8px 24px rgba(22, 163, 74, 0.35)",
      }}
    >
      <Phone className="h-4 w-4" />
      <span className="text-xs hidden sm:inline">Call Us</span>
    </a>
  );
}
